<style lang="scss" scoped>
@import "./onlineaccount.css";
</style>
<template>
  <div id="onlineaccount">
    <div class="topHeader">
      <a-form-model
        :model="params"
        style="width: 100%"
        labelAlign="right"
        layout="inline"
      >
        <a-row type="flex" justify="space-between">
          <a-col :xl="{ span: 6 }">
            <a-form-model-item label="國家地區" class="formItem">
              <Situationall
                v-model="params.area"
                :url="$api.getParamList"
                ref="seachope"
                :params="{ type: 'kharea' }"
                :style="'width:100%'"
                :placeholder="'請選擇國家地區'"
              >
              </Situationall>
            </a-form-model-item>
          </a-col>
          <a-col :xl="{ span: 6 }">
            <a-form-model-item label="客服姓名" class="formItem">
              <a-input v-model="params.kefname" placeholder="請輸入客服姓名" :allowClear="true" @change="handleClear(1)"/>
            </a-form-model-item>
          </a-col>
          <a-col :xl="{ span: 6 }">
            <a-form-model-item label="提交日期" class="formItem">
              <a-range-picker
                :placeholder="['開始時間', '結束時間']"
                format="YYYY/MM/DD"
                v-model="params.timeDate"
                @change="fanhand"
              >
              </a-range-picker>
            </a-form-model-item>
          </a-col> </a-row
        ><br />
        <a-row type="flex" justify="space-between">
          <a-col :xl="{ span: 6 }">
            <a-form-model-item label="信息查詢" class="formItem">
              <a-input
                v-model="params.searchstr"
                placeholder="請輸入查詢信息"
                :allowClear="true" @change="handleClear(2)"
              />
            </a-form-model-item>
          </a-col>
          <a-col :xl="{ span: 6 }">
            <a-form-model-item label="回訪狀態" class="formItem">
              <a-select
                v-model="params.kfstatus"
                placeholder="請選擇"
                @change="searchEvent"
              >
                <a-select-option
                  v-for="item in admintypeArr"
                  :key="item.key"
                  :value="item.value"
                  style="width: 100%"
                  >{{ item.text }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :xl="{ span: 6 }" style="display: inline-flex;align-items: center;" >
            <div
              class="btn_cla"
              style="background-color: #3bc7a1; margin-right :1rem;"
              @click="searchEvent"
            >
              <img src="../../image/icon_sousuo.png" class="btnIcon" />
              <span>搜索</span>
            </div>
            <div
              class="btn_cla"
              style="background-color: #ffa647; "
              @click="clearEvent"
            >
              <img src="../../image/icon_chongzhi.png" class="btnIcon" />
              <span>重置</span>
            </div>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <div class="bottomMain">
      <div class="tableBtnView">
        <div  @click="upClick()" style="cursor:pointer;">
          <!-- handopen -->
          <!-- <img :src="require('../../image/pdf.png')" class="btnIcon" style='width: .9rem'/> -->
          <a-icon
            type="file-pdf"
            style="
              width: 0.9rem;
              color: #3bc7a1;
              marginright: 0.3rem;
              fontsize: 0.8rem;
            "
          />
          <span style="color: #3bc7a1">導出</span>
        </div>
        <div @click="delClick" style="margin-left: 15px;cursor:pointer;">
          <!-- handopen -->
          <!-- <img :src="require('../../image/pdf.png')" class="btnIcon" style='width: .9rem'/> -->
          <a-icon
            type="delete"
            style="
              width: 0.9rem;
              color: #ED4849;
              marginright: 0.3rem;
              fontsize: 0.8rem;
            "
          />
          <span style="color: #ED4849">刪除</span>
        </div>
      </div>
      <a-table
        style="width: 100%"
        :columns="columns"
        :data-source="columnsData"
        id="fromtable"
        :rowKey="(record, index) => index"
        :row-selection="{
          selectedRowKeys: selectedRows,
          onChange: onSelectChange,
        }"
        :pagination="false"
        :bordered="true"
      >
        <span
          slot="alltext"
          style="font-size: 0.85rem; position: relative; left: -2.8rem"
        ></span>
        <div
          slot="a"
          slot-scope="record"
          style="position: relative; left: 1rem"
        >
          <a-badge
            v-if="record.kfstatus !== '已取消' && record.khtimes > 1"
            :count="record.khamount"
            :overflow-count="99"
            :number-style="{
              backgroundColor:
                record.kfstatus == '已提交' || record.cancelflag == 1
                  ? '#999'
                  : 'rgb(12, 139, 151)',
              marginTop: '-.3rem',
              padding: '0',
            }"
          >
            <div style="width: 1.2rem; text-align: right">
              <img
                :src="require('../../image/dianhua2.png')"
                class="btnIcon"
                style="width: 1.1 rem"
              />
            </div>
          </a-badge>
        </div>
        <div
          slot="telphonenumber"
          slot-scope="record"
          :style="{
            color:
              record.kfstatus == '已提交' || record.cancelflag == 1
                ? '#999'
                : '',
          }"
          style="position: relative;text-align: left; margin-left: 12%"
        >
        <span v-if="httpFlag">
          <span style="color:red;font-size:0.7rem;position: absolute; left: -35px; top: 2px;" v-if="
              record.phonenum == 6666666 ||
              record.phonenum == 8888888 ||
              record.phonenum == 97950637
              "
          >
              Test
          </span>
        </span>
        <span v-else>
          <span style="color:red;font-size:0.7rem;position: absolute; left: -35px; top: 2px;" v-if="
              record.phonenum == 15640838820 ||
              record.phonenum == 97950637 "
          >
              Test
          </span>
        </span>
          {{ record.telphonenumber }}
        </div>
        <div
          slot="area"
          slot-scope="record"
          :style="{
            color:
              record.kfstatus == '已提交' || record.cancelflag == 1
                ? '#999'
                : '',
            width: '75%',
          }"
          style="text-align: left; margin-left: 12%"
        >
          {{ record.area }}
        </div>
        <div
          slot="en_name"
          slot-scope="record"
          :style="{
            color:
              record.kfstatus == '已提交' || record.cancelflag == 1
                ? '#999'
                : '',
          }"
        >
          {{ record.en_name }}
        </div>
        <div
          slot="cn_name"
          slot-scope="record"
          :style="{
            color:
              record.kfstatus == '已提交' || record.cancelflag == 1
                ? '#999'
                : '',
          }"
        >
          {{ record.cn_name }}
        </div>
        <div
          slot="name"
          slot-scope="record"
          :style="{
            color:
              record.kfstatus == '已提交' || record.cancelflag == 1
                ? '#999'
                : '',
          }"
        >
          <!-- <div :style="{color:record.name?'':'red'}"> -->
          {{ record.name || "無記錄" }}
          <!-- </div> -->
        </div>
        <div
          slot="step"
          slot-scope="record"
          :style="{
            color:
              record.kfstatus == '已提交' || record.cancelflag == 1
                ? '#999'
                : '',
          }"
          style="text-align: left; margin-left: 12%"
        >
          {{ record.step }}
        </div>
        <div
          slot="step_datetime"
          slot-scope="record"
          :style="{
            color:
              record.kfstatus == '已提交' || record.cancelflag == 1
                ? '#999'
                : '',
          }"
        >
          {{ record.step_datetime }}
        </div>
        <div
          slot="kefname"
          slot-scope="record"
          :style="{
            color:
              record.kfstatus == '已提交' || record.cancelflag == 1
                ? '#999'
                : '',
          }"
        >
          {{ record.kefname }}
        </div>
        <div slot="kfstatus" slot-scope="record" style="white-space: nowrap">
          <div
            v-if="record.kfstatus == '跟進中'"
            :style="{
              color:
                record.kfstatus == '已提交' || record.cancelflag == 1
                  ? '#999'
                  : '',
            }"
          >
            <!-- #3bc7a1 -->
            <a-badge
              :count="record.amount"
              :overflow-count="99"
              style=" left:`100px`,
                top:`0px`"
              :number-style="{
                backgroundColor:
                  record.kfstatus == '已提交' || record.cancelflag == 1
                    ? '#999'
                    : '',
                marginTop: '-.3rem',
                padding: '0',
              }"
            >
              <span
                style="font-size: 0.85rem !important; color: rgb(59, 199, 161)"
                >跟進中</span
              ></a-badge
            >
          </div>
          <div
            v-if="record.kfstatus == '已提交'"
            :style="{
              color:
                record.kfstatus == '已提交' || record.cancelflag == 1
                  ? '#999'
                  : '',
            }"
          >
            已提交
            <!-- rgb(93, 176, 234) -->
            <!-- 	<a-badge :count="record.amount" :overflow-count="99" style=' left:`100px`,
						top:`0px`' :number-style="{backgroundColor: record.kfstatus == '已提交'||record.cancelflag==1?'#999':'',marginTop: '-.3rem',padding: '0'}">
							</a-badge> -->
          </div>
          <div
            v-if="record.kfstatus == '未跟進'"
            :style="{
              color:
                record.kfstatus == '已提交' || record.cancelflag == 1
                  ? '#999'
                  : '#ee5253',
            }"
          >
            未跟進
            <!-- #ee5253 -->
          </div>
          <div
            v-if="record.kfstatus == '已取消'"
            :style="{
              color:
                record.kfstatus == '已提交' || record.cancelflag == 1
                  ? '#999'
                  : '',
            }"
          >
            已取消
          </div>
          <!-- #000 -->
        </div>
        <!-- 控制按鈕 -->
        <div slot="toolArr" slot-scope="record">
          <div class="tableRowView2">
            <div>
              <!-- <img :src="visible_bold ? icon_pdf1 : icon_pdf"
								class="imageC"  @click='visible_bold = true'> -->
              <img
                :src="icon_pdf"
                :style="{
                  opacity:
                    record.kfstatus == '已提交' || record.cancelflag == 1
                      ? '.5'
                      : '1',
                }"
                class="imageC"
                @click="
                  visible_bold = true;
                  itemobj = record;
                "
              />
            </div>
          </div>
        </div>
      </a-table>
      <div class="paginationView">
        <div>
          第{{ firstPage }}到{{ secPage }}條，共{{ params.total }}條記錄
        </div>
        <div style="margin-left: auto">
          <a-pagination
            v-model="params.pageNum"
            @change="pageChange"
            :total="params.total"
            :pageSize="params.perPage"
          />
        </div>
        <div class="pageTzView">
          <input
            type="text"
            v-model="tzPageNum"
            @onkeyup="valueFn"
            @onafterpaste="valueFn"
          />
          <span @click="tzEvent">跳轉</span>
        </div>
      </div>
    </div>
    <div
      :class="['pdfview', pdfShow ? 'pdfShow' : '']"
      @click="pdfShowUNEvent()"
    >
      <div class="pdfviewIn">
        <div class="pdfTitle">
          <img @click.stop="printEvent()" src="../../image/icon_dayin.png" />
        </div>
        <iframe
          id="iframePdf1"
          :src="allurl"
          style="width: 100%; height: 100%"
          frameborder="0"
        ></iframe>
        <iframe
          id="toPrintIframe"
          style="display: none"
          :src="pdfBolUrl"
          frameborder="0"
        ></iframe>
      </div>
    </div>
    <handItem
      v-if="visible_bold"
      @child="handclose"
      :itemobj="itemobj"
    ></handItem>
    <exportData  v-if="upFlag" @child="upclose" ></exportData>
    <!-- 搜索无结果弹窗 -->
    <div>
      <a-modal  id='handout' width='25rem' v-model="ishandout" on-ok="handleOk1" v-dragModal :dialog-style='{top:"30vh"}'  @cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
        <div class='mark-file' style="overflow: hidden;width: 100%;borderBottom: 1px solid #f1f1f1;">
            <div style="border-radius:0;width: 23rem;float: right;background-color: #fff;color:#000;text-align: left;padding-bottom: .5rem 0;position: relative;top: -.5rem;left: -0.5rem;">
                提 示
            </div>
        </div>
        <div solt='title' style="position: relative;"></div>
        <div style='margin-top: 3rem;height: 3rem;font-size:.8rem;line-height:3rem;display: flex;align-items: center;'>
            <a-icon type="exclamation-circle" style='font-size: 1.2rem;color: orange;margin-right:.5rem;'/>	搜索內容不存在
        </div>
        <div style="text-align: right">
            <button class='btn-main btn-main1' @click='ishandout = false'>取 消</button>
            <button class='btn-main' @click='ishandout = false'>確 認</button>
        </div>
      </a-modal>
    </div>
  </div>
</template>
<script>
import exportData from "./components/exportData";
import https from "@/plugins/http.js";
import App from "@/assets/app.js";
import icon_pdf from "@/image/icon_xiangqing.png";
import icon_pdf1 from "@/image/icon_xiangqing_1.png";
import handItem from "./components/handItem";

export default {
  components: {
    handItem,
    exportData
  },
  data() {
    return {
      httpFlag:window.location.protocol == 'https:',
      upFlag:false,
      ishandout:false,
      allurl: "",
      pdfShow: false,
      pdfBolUrl: "",
      itemobj: {},
      visible_bold: false,
      //: "編輯管理員": "ipoAdmin"有新增 编辑权限
      ipoAdmin: this.$store.state.rolesdata.indexOf("ipoAdmin") >= 0,
      icon_pdf,
      icon_pdf1,
      admintypeArr: [
        {
          text: "全部",
          value: "",
        },
        {
          text: "跟進中",
          value: "1",
        },
        {
          text: "未跟進",
          value: "2",
        },
        {
          text: "已取消",
          value: "3",
        },
        {
          text: "已提交",
          value: "4",
        },
      ],
      tzPageNum: "",
      columns: [
        // {
        // 	// title: '',
        // 	dataIndex: '',
        // 	align: 'right',
        // 	width: '5%',
        // 	slots: {
        // 		title: 'alltext'
        // 	},
        // 	scopedSlots: {
        // 		customRender: 'a'
        // 	}
        // },
        {
          title: "區域/號碼",
          dataIndex: "",
          align: "center",
          width: "12%",
          scopedSlots: {
            customRender: "telphonenumber",
          },
        },
        {
          title: "國家/地區",
          dataIndex: "",
          align: "center",
          width: "12%",
          scopedSlots: {
            customRender: "area",
          },
        },
        {
          title: "中/英文姓名",
          dataIndex: "",
          align: "center",
          width: "13%",
          scopedSlots: {
            // customRender:'cn_name',
            customRender: "name",
          },
        },
        // {
        // 	title: '英文姓名',
        // 	dataIndex: '',
        // 	align: 'center',
        // 	width: '12%',
        // 	scopedSlots:{
        // 		customRender:'en_name'
        // 	}
        // },
        {
          title: "開戶進度",
          dataIndex: "",
          align: "center",
          width: "13%",
          scopedSlots: {
            customRender: "step",
          },
        },
        {
          title: "提交日期",
          dataIndex: "",
          align: "center",
          width: "13%",
          scopedSlots: {
            customRender: "step_datetime",
          },
        },
        {
          title: "客服姓名",
          dataIndex: "",
          align: "center",
          width: "13%",
          scopedSlots: {
            customRender: "kefname",
          },
        },
        {
          title: "回訪狀態",
          dataIndex: "",
          align: "center",
          width: "13%",
          scopedSlots: {
            customRender: "kfstatus",
          },
        },
        {
          title: "操作",
          dataIndex: "",
          align: "center",
          width: "auto",
          scopedSlots: {
            customRender: "toolArr",
          },
        },
      ],
      columnsData: [],
      selectedRows: [], //checkbox
      params: {
        // 任務數
        missionnum: 0,
        pageNum: 1, //當前頁數
        total: 1,
        searchstr: "",
        perPage: 10, //每頁條目數
        area: "",
        kefname: "",
        kfstatus: "",
        plates_cn: "",
        begindate: "", //認購起始日期
        enddate: "", //認購截止日期
        timeDate: [],
      },
	  unsubmitusers:[]
    };
  },
  created() {},
  computed: {
    firstPage: function () {
      let _this = this;
      let a = (_this.params.pageNum - 1) * 10;
      let b = 1;
      return _this.params.total > 0 ? Number(a) + Number(b) : 0;
    },
    secPage: function () {
      let _this = this;
      let a = _this.params.pageNum * 10;
      let b = a > _this.params.total ? _this.params.total : a;
      return b;
    },
  },
  mounted() {
    this.messLoad();
    console.log(this.$router);
  },
  methods: {
    upClick(){
      this.upFlag = true
    },
    upclose(val){
      this.upFlag = false;
      if (val.xzgs == 'PDF') {
        this.pdfEvent(val.pxfs)
      }
      if (val.xzgs == 'Excel') {
        this.queryData(val.pxfs)
      }
    },
    // 表格导出下载
    queryData(pxfs){
      if (this.params.timeDate.length<=0) {
        App.oTool.warningT('請選擇提交日期');
        return
      }
      let sort =  pxfs == undefined ? '' : pxfs
      let url = this.$api.unSubmittedAccount;
      // url += '?m=' + Date.parse(new Date())
      url +="?begindate=" + this.params.begindate 
          +"&enddate=" + this.params.enddate 
          +'&sort=' + sort
          +"&area=" + this.params.area 
          +"&kefname=" + this.params.kefname 
          +"&searchstr=" + this.params.searchstr 
          +"&kfstatus=" + this.params.kfstatus 
          +"&token=" + this.$store.state.token 
          +"&m=" + Date.parse(new Date());
      window.location.href = url;
    },
    handleCancel(ev){
      this.ishandout = false
    },
    handleClear(ind){
      if (ind == 1) {
        if (!this.params.kefname) {
            this.messLoad()
        }
      }
      if (ind == 2) {
        if (!this.params.kefname) {
            this.messLoad()
        }
      }
    },
    // 删除
	delClick(){
		console.log('删除按钮',this.unsubmitusers);
    // this.$confirm("是否刪除此數據，刪除後不可恢復", "是否刪除？", {
    //     confirmButtonText: "確認",
    //     cancelButtonText: "取消",
    //     confirmButtonClass: "confirmbtn",//自定义class
    //     type: "warning"
    // }).then(() => {

    //     next()
    // }).catch(() => {
    // })
		if(this.unsubmitusers.length>0){
      this.$confirm("是否刪除此數據，刪除後不可恢復", "是否刪除？", {
          confirmButtonText: "確認",
          cancelButtonText: "取消",
          confirmButtonClass: "confirmbtn",//自定义class
          type: "warning"
      }).then(() => {
        this.$ajax({
          method: "post",
          url: this.$api.clearUserKhMsg,
          // url: this.$api.getUserFileStatusDetail,
          data: {
            unsubmitusers:this.unsubmitusers
          },
        }).then((res) => {
          if (res.data.qmiscode == 1000) {
            this.$message.success('删除成功')
            this.messLoad();
            // this.$router.go(0)
          } else {
            App.oTool.warningT(res.data.qmismsg);
          }
        });
        next()
      }).catch(() => {
      })

		}
	},
  // pdf导出
    pdfEvent(pxfs) {
      if (this.params.timeDate.length<=0) {
        App.oTool.warningT('請選擇提交日期');
        return
      }
      console.log(this.$api.pdfs);
      let sort =  pxfs == undefined ? '' : pxfs
      let str = this.$api.pdfs; //getUnsk
      let url = this.$api.getUnsk;
      // url += '?m=' + Date.parse(new Date())
      url +="?begindate=" + this.params.begindate 
          +"&enddate=" + this.params.enddate 
          +'&sort=' + sort
          +"&area=" + this.params.area 
          +"&kefname=" + this.params.kefname 
          +"&searchstr=" + this.params.searchstr 
          +"&kfstatus=" + this.params.kfstatus 
          +"&token=" + this.$store.state.token 
          +"&m=" + Date.parse(new Date());
      this.allurl = str + url;
      let _this = this;
      _this.pdfUrl = url;
      https
        .fetchGetPdf(_this.pdfUrl)
        .then((data) => {
          let blob = new Blob([data], {
            type: "application/pdf",
          });
          _this.blob = blob;
          let b = window.URL.createObjectURL(blob);
          _this.pdfBolUrl = b;
        })
        .catch((err) => {
          console.log(err);
        });

      setTimeout(() => {
        this.pdfShow = true;
      }, 500);
      // window.open(this.$api.openurls+ "/dalinji")
    },
    printEvent() {
      let _this = this; //toPrintIframe
      const printIframe = document.getElementById("toPrintIframe");
      let frameWindow = printIframe.contentWindow;
      console.log(frameWindow);
      frameWindow.print();
      setTimeout(() => {
        window.URL.revokeObjectURL(_this.blob);
      }, 500);
    },
    pdfShowUNEvent() {
      this.pdfShow = false;
      // this.messLoad();
    },
    handopen() {
      this.$ajax({
        url: this.$api.getpdfable,
        method: "post",
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          window.location.href =
            this.$api.getUn +
            "?token=" +
            this.$store.state.token +
            "&m=" +
            Date.parse(new Date()) +
            "&begindate=" +
            this.params.begindate +
            "&enddate=" +
            this.params.enddate;
          // window.location.href = this.$api.getExcel+'?token=' + this.$store.state.token + '&m=' + Date.parse(new Date())
        }
      });
    },
    // 复选框监听
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRows = selectedRowKeys;
	  console.log(this.selectedRows,'复选框查看',selectedRows);
	  this.unsubmitusers = []
	  for (let i = 0; i < selectedRows.length; i++) {
		 this.unsubmitusers.push(selectedRows[i].id)
		
	  }
    },

    valueFn() {
      this.tzPageNum = this.tzPageNum.replace(/\D/g, "");
    },
    fanhand(val) {
      (this.params.begindate = this.params.timeDate[0]
        ? App.oDate.secsTime3(this.params.timeDate[0]._d)
        : ""),
        //認購截止日期
        (this.params.enddate = this.params.timeDate[1]
          ? App.oDate.secsTime3(this.params.timeDate[1]._d)
          : "");
    },
    handland(val) {
      this.$ajax({
        method: "post",
        url: this.$api.getParamList,
        headers: {
          token: this.$store.state.token,
        },
        data: {
          type: val,
        },
      })
        .then((res) => {
          if (res.data.qmiscode === 1000) {
          } else {
            App.oTool.warningT(res.data.qmismsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 关闭弹窗
    handclose(val) {
      this.itemobj = {};
      this.visible_bold = false;
      if (val) {
        this.messLoad();
      }
    },
    messLoad() {
      this.selectedRows = [];
      this.$ajax({
        method: "post",
        url: this.$api.getUnsubmittedKh,
        headers: {
          token: this.$store.state.token,
        },
        data: this.params,
      })
        .then((res) => {
          if (res.data.qmiscode === 1000) {
            this.columnsData = res.data.unsubmittedKhList;
            this.columnsData.map((ev) => {
              for (let key in ev) {
                ev["visible_bold"] = false;
              }
            });
			      console.log('1221313131',this.columnsData);
            this.params.pageNum = res.data.pageNum;
            this.params.perPage = res.data.perPage;
            this.params.pages = res.data.pages;
            this.params.total = res.data.total;
            this.params.missionnum = res.data.missionnum;
            // 123123
            if (this.params.area || this.params.kefname || this.params.begindate || this.params.searchstr || this.params.kfstatus) {
              if (this.columnsData.length<=0) {
                this.ishandout = true
              }
            }
        } else {
            App.oTool.warningT(res.data.qmismsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    searchEvent() {
      this.params.pageNum = 1;
      this.messLoad();
    },
// 重置
    clearEvent() {
      this.params = {};
      this.params = {
        pageNum: 1, //當前頁數
        total: 1,
        perPage: 10, //每頁條目數
        area: "", //李百控股    股票名稱
        kefname: "", //客服姓名
        begindate: "", //認購起始日期
        enddate: "", //認購截止日期
        timeDate: [],
      };
      this.$refs["seachope"].handleSearch("");
      this.messLoad();
    },
    // 页码跳转
    tzEvent() {
      let _this = this;
      let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
      if (_this.tzPageNum <= maxPageNum) {
        _this.params.pageNum = Number(_this.tzPageNum);
        _this.messLoad();
      } else {
        App.oTool.warningT("請輸入有效的頁碼");
      }
    },
    pageChange(page, pageSize) {
      this.params.pageNum = page;
      this.messLoad();
    },
  },
};
</script>
<style lang='scss'>
  *, *::before, *::after{
      font-family: 'element-icons';

  }
  .confirmbtn{
      color: #FFFFFF !important;
      background-color: #09666e!important;
      border-color: #09666e!important;
  }
  .el-button--small:hover{
      background-color: #ffffff ;
      border-color: #dcdfe6 ;
      color: #000;
  }
#onlineaccount {
  .pdfview {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0vw;
    top: 0vh;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 99;
    display: none;
  }

  .pdfShow {
    display: block;
  }

  .pdfview .pdfviewIn {
    position: fixed;
    width: 80vw;
    height: 80vh;
    left: calc(50% - 40vw);
    top: 5vh;
  }

  .pdfview .pdfviewIn .pdfTitle {
    /* position: absolute;
		    top: 1rem;
		    right:3rem; */
    height: 3rem;
    background-color: #fff;
    width: calc(100% + 1px);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 2rem;
  }

  .pdfview .pdfviewIn .pdfTitle img {
    width: 1.5rem;
    height: 1.5rem;
    margin-left: 1rem;
    cursor: pointer;
  }
}
</style>
